import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogBody,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { getKBBoundedAssistants } from "./service";
import { useEffect, useState } from "react";
import { message } from "antd";
import { CheckboxField, Checkbox } from "V2.0/common/checkbox";
import { Label, Description } from "V2.0/common/fieldset";

function KnowledgeBaseDelete(props) {
  const { workspaceId, open, onClose, onDelete, item, loading } = props;
  const [disabled, setDisabled] = useState(true);
  const [kbBoundedAssistants, setKbBoundedAssistants] = useState([]);

  const [isForceDeleteConfirm, setIsForceDeleteConfirm] = useState(false);

  const fetchBoundedAssistants = async () => {
    try {
      const response = await getKBBoundedAssistants({
        workspaceId,
        kbId: item._id,
      });
      if (response.status === 200) {
        const assistants = response.data.assistants.map(
          (assistant) => assistant.name
        );
        if (assistants.length === 0) {
          setDisabled(false);
        }
        setKbBoundedAssistants(assistants);
      }
    } catch (e) {
      message.error("Error deleting knowledge base");
      onClose();
    }
  };

  useEffect(() => {
    if (workspaceId) {
      fetchBoundedAssistants();
    }
  }, [workspaceId]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete {item.label}?</DialogTitle>
      {kbBoundedAssistants.length > 0 && (
        <DialogBody>
          <p>
            {item.label} is used by - {kbBoundedAssistants.join(", ")}. 
          </p>
          <div className="mt-4">
            <CheckboxField>
              <Checkbox
                name="ghl_crm_search"
                onChange={() => {
                  setDisabled((prevState) => !prevState);
                  setIsForceDeleteConfirm(true);
                }}
                checked={!disabled}
              />
              <Label>Confirm</Label>
              <Description>Please, confirm to delete</Description>
            </CheckboxField>
          </div>
        </DialogBody>
      )}
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button
          disabled={disabled}
          loading={loading}
          onClick={() => onDelete(item._id, isForceDeleteConfirm)}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { KnowledgeBaseDelete };
